/**
 * <TutorRowSkeleton> — la forme d'une ligne de tuteur pendant le chargement.
 *
 * La capsule, le nom, la légende : la géométrie est celle de `<TutorRow>`, importée et non
 * recopiée.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { CardListRow } from "../CardList"
import { BOW_ROOM } from "../SessionRow/SessionRow"
import { TUTOR_AVATAR_SIZE } from "./TutorRow"

export function TutorRowSkeleton() {
    return (
        <CardListRow>
            <Row gap="3" align="center" style={styles.line}>
                <Skeleton shape="circle" size={TUTOR_AVATAR_SIZE} />
                <Stack gap="0" style={styles.body}>
                    <Skeleton textSize="text-md" width={110} />
                    <Skeleton textSize="text-sm" width={80} />
                </Stack>
            </Row>
        </CardListRow>
    )
}

const styles = StyleSheet.create(() => ({
    line: { paddingBottom: BOW_ROOM },
    body: { flex: 1, flexShrink: 1 },
}))
